/**
 * Bridge: Code Black Belt "Also Bought" → Enterprise Cart Drawer + Card Data.
 * CBB unterstützt Enterprise nicht als Theme-Default; nach ATC
 * öffnen/aktualisieren wir den Drawer. Grundpreis + USP kommen aus
 * /products/{handle}?view=card-data (CBB liefert beides nicht).
 */
(function () {
  'use strict';

  if (window.__supplementaCbbCartLoaded) return;
  window.__supplementaCbbCartLoaded = true;

  var LOADING_CLASS = 'is-loading';
  var LOADING_MAX_MS = 8000;
  var UNIT_CLASS = 'cbb-also-bought-unit-price';
  var DESC_CLASS = 'cbb-also-bought-desc';
  var CARD_SEL = '.cbb-also-bought-product';
  var BTN_SEL = '.cbb-also-bought-add-to-cart-button';
  var productCache = {};

  var lastOpener = null;
  var loadingBtn = null;
  var loadingTimer = null;
  var errorObserver = null;

  function stopLoading() {
    if (loadingTimer) {
      clearTimeout(loadingTimer);
      loadingTimer = null;
    }
    if (errorObserver) {
      errorObserver.disconnect();
      errorObserver = null;
    }
    if (loadingBtn) {
      loadingBtn.classList.remove(LOADING_CLASS);
      loadingBtn.style.removeProperty('min-width');
      loadingBtn.style.removeProperty('min-height');
      loadingBtn = null;
    }
  }

  function watchErrorFor(btn) {
    var card = btn.closest(CARD_SEL);
    var errorEl = card && card.querySelector('.cbb-also-bought-error');
    if (!errorEl) return;
    errorObserver = new MutationObserver(function () {
      if (errorEl.style.display && errorEl.style.display !== 'none') {
        stopLoading();
      }
    });
    errorObserver.observe(errorEl, { attributes: true, attributeFilter: ['style'] });
  }

  function startLoading(btn) {
    stopLoading();
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    btn.style.setProperty('min-width', rect.width + 'px', 'important');
    btn.style.setProperty('min-height', rect.height + 'px', 'important');
    loadingBtn = btn;
    btn.classList.add(LOADING_CLASS);
    watchErrorFor(btn);
    loadingTimer = setTimeout(stopLoading, LOADING_MAX_MS);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function formatUnitPrice(variant) {
    if (!variant || !variant.unit_price_measurement || variant.unit_price == null) {
      return '';
    }
    var m = variant.unit_price_measurement;
    var ref = m.reference_value && m.reference_value !== 1
      ? String(m.reference_value) + ' '
      : '';
    return formatMoney(variant.unit_price) + ' / ' + ref + m.reference_unit;
  }

  function getHandle(card) {
    var link = card.querySelector(
      '.cbb-also-bought-product-name a[href*="/products/"], .cbb-also-bought-product-image-link[data-href*="/products/"]'
    );
    var href = link && (link.getAttribute('href') || link.getAttribute('data-href') || '');
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getSelectedVariantId(card) {
    var select = card.querySelector('.cbb-recommendations-variant-select');
    if (!select || !select.options.length) return null;
    var opt = select.options[select.selectedIndex] || select.options[0];
    var id = opt && opt.dataset.variantId;
    return id ? String(id) : null;
  }

  function fetchCardData(handle) {
    if (productCache[handle]) return productCache[handle];
    // Kein Accept-Header: Shopify liefert bei `application/json`
    // stattdessen das eingebaute product.js-JSON.
    productCache[handle] = fetch(
      '/products/' + encodeURIComponent(handle) + '?view=card-data'
    )
      .then(function (res) {
        if (!res.ok) throw new Error('card-data fetch failed');
        return res.json();
      })
      .catch(function () {
        delete productCache[handle];
        return null;
      });
    return productCache[handle];
  }

  function findVariant(data, variantId) {
    if (!data || !data.variants || !data.variants.length) return null;
    if (variantId) {
      for (var i = 0; i < data.variants.length; i += 1) {
        if (String(data.variants[i].id) === variantId) return data.variants[i];
      }
    }
    return data.variants[0];
  }

  function upsertAfter(card, cls, tag, anchor, text) {
    var el = card.querySelector('.' + cls);
    if (!text) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement(tag);
      el.className = cls;
      anchor.insertAdjacentElement('afterend', el);
    }
    el.textContent = text;
  }

  function enrichCard(card) {
    var handle = getHandle(card);
    if (!handle) return;
    fetchCardData(handle).then(function (data) {
      if (!data || !card.isConnected) return;
      var name = card.querySelector('.cbb-also-bought-product-name');
      var btn = card.querySelector(BTN_SEL);
      if (name) upsertAfter(card, DESC_CLASS, 'p', name, data.usp || '');
      var variant = findVariant(data, getSelectedVariantId(card));
      if (btn) upsertAfter(card, UNIT_CLASS, 'div', btn, formatUnitPrice(variant));
    });
  }

  function enrichAll() {
    var cards = document.querySelectorAll(CARD_SEL);
    for (var i = 0; i < cards.length; i += 1) enrichCard(cards[i]);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest(BTN_SEL);
    if (!btn) return;
    lastOpener = btn;
    startLoading(btn);
  }, true);

  document.addEventListener('codeblackbelt:also-bought:added', function () {
    stopLoading();
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
      bubbles: true,
      detail: { opener: lastOpener }
    }));
  });

  document.addEventListener('codeblackbelt:also-bought:rendered', enrichAll);

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.classList || !select.classList.contains('cbb-recommendations-variant-select')) return;
    var card = select.closest(CARD_SEL);
    if (card) enrichCard(card);
  });

  // Falls Widget schon gerendert wurde, bevor dieses Script lief
  if (document.querySelector(CARD_SEL)) enrichAll();
})();
